import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { FaTrash } from "react-icons/fa";
import api from '../../api/manage_database/ConverterReq';
import SelectConverter from '../../components/SelectConverter';
import BackButton from "../../components/BackButton";
import { toast } from 'sonner';


const ConverterDelete = () => {
    const [Converters, setConverters] = useState([]);
    const [selectedConverter, setSelectedConverter] = useState('');

    const [converterData, setConverterData] = useState();
    
    const navigate = useNavigate();

    useEffect(() => {
        const fetchConverters = async () => {
            try {
                const response = await api.get('all', {withCredentials: true});
                if (response.data.success) {
                    setConverters(response.data.payload);
                } else {
                    toast.error('Not got data from database');
                }
            } catch (err) {
                console.log(err.response);
            }
        };

        fetchConverters();
    }, []);
    
    const handleDelete = () => {
        const fetchRecord = async () => {
            try {
                const response = await api.get(`record/${selectedConverter}`, {withCredentials: true});
                if (response.data.success) {
                    setConverterData(response.data.payload[0]);
                } else {
                    toast.error('Not got data from database');
                }
                
            } catch (err) {
                console.log(err.response);
            }
        }
        fetchRecord();
    }

    useEffect(() => {
        const deleteRecord = async () => {
            try {
                const response = await api.delete(`record/${selectedConverter}`, {withCredentials: true});
                if (response.data.success) {
                    toast.success(`${response.data.message}`);
                    navigate(
                        `../record/${selectedConverter}`,
                        {
                            state: {
                                deleteRecordMessage: 'Deleted record from database!',
                                anotherTypeOfPage: true,
                                data: converterData
                            }
                        }
                    )
                } else {
                    toast.error('Something go wrong! Maybe check internet connection');
                }
            } catch (err) {
                console.log(err.response);
            }
        }

        if (converterData) {
            deleteRecord();
        }
    }, [converterData]);

    return (
        <div className='converter-delete-container'>
            <h2 className='converter-delete-title'>Converter</h2>
            <div className='converter-delete-card'>
                <div className='converter-delete-label-select-wrapper'>
                    <label
                        htmlFor='converter-select'
                        className='bold-label'
                    >
                        Converter:
                    </label>
                    <SelectConverter
                        Converters={Converters}
                        selectedConverter={selectedConverter}
                        setSelectedConverter={setSelectedConverter}
                    />
                </div>
                <button className='converter-delete-button' onClick={handleDelete}>Delete &nbsp; <FaTrash /></button>
            </div>
            <BackButton navigateTo='/manage-database'/>
        </div>
    ); 
};

export default ConverterDelete;